import { CreateStaffStepProgression } from './select-staff.progression';
import type { SelectStaffState } from './select-staff.reducer';

export function selectCreateStaffProgression(state: SelectStaffState) {
    return CreateStaffStepProgression[state.step](state);
}
